<template>
    <div>
        <div style="display: flex;">
            <div v-for="(user, index) in user_list" :key="index" style="display: flex;align-items: center;width: 300px;height: 80px;border: 1px solid #a2a2a2;border-radius: 10px;margin: 10px;padding: 10px;">
                <img style="width: 60px;height: 60px;border-radius: 50%;" :src="user.user_avatar" alt="" srcset="">
                <div style="width: 40px;margin: 0 10px;text-align: center;">{{ user.id }}</div>
                <div style="flex-grow: 1;">{{ user.user_name }}</div>
                <el-button @click="DelUser(user.id)" type="danger" round>Delete</el-button>
            </div>
        </div>
        <div>
          <el-Input style="width: 300px;margin: 40px 40px 0;" placeholder="User ID" v-model="add_uid"></el-Input>
          <el-button @click="AddUser" type="primary">Add</el-button>
        </div>
    </div>
</template>
<script>
    import {getConfig, saveConfig} from "@/utils/api";
    export default {
        data: () => {
            return {
                add_uid: '', 
                door_user: '',
                user_list: []
            }
        },
        methods: {
            getConfig() {
                getConfig('door_user').then(res => {
                    console.log(res)
                    if (res.door_user) {
                        this.door_user = res.door_user
                        this.user_list = res.user_list
                    } else {
                        this.user_list = []
                    }
                })
            },
            DelUser(uid) {
                let arr = this.door_user.split(',')
                arr.splice(arr.indexOf(String(uid)), 1)
                let value = arr.join(',')
                saveConfig({
                    key: 'door_user',
                    value
                }).then(res => {
                    // console.log(res)
                    this.$message.success('Saved');
                    this.getConfig()
                })
            },
            AddUser() {
                let value = this.add_uid
                let typeTest = parseInt(value)
                if (!typeTest) return this.$message.error('Please make sure your submit is an User ID!');
                if (this.door_user) {
                    let arr = this.door_user.split(',')
                    console.log("arr", arr)
                    if (arr.indexOf(this.add_uid) < 0) {
                        value = this.door_user + ',' + this.add_uid
                    } 
                } 
                saveConfig({
                    key: 'door_user',
                    value
                }).then(res => {
                    // console.log(res)
                    this.$message.success('Saved');
                    this.getConfig()
                })
            }
        },
        beforeMount(){
            this.getConfig()
        },
    }
</script>